"use strict";
/**
 * @author Maxim Seredkin
 */
export default function () {
  return {
    restrict: "A",
    template: require("../view/project-tab-lands.html"),
    scope: {
      edit: "=edit",
      upload: "=upload",
      resourceSupport: "=myResourceSupport",
      project: "=myProject",
    },
    controller: [
      "$scope",
      function ($scope) {
        $scope.isSelect = isSelect;
        $scope.landsOptions = [
          "<Все>",
          "Газоснабжение",
          "Электроснабжение",
          "Водоснабжение",
          "Водоотведение",
          "Транспортная инфраструктура",
        ];
        $scope.landFilter = $scope.landsOptions[0];

        $scope.getSplashImage = function () {
          if ($scope.project.imageAttachment && $scope.project.imageAttachment.id) {
            return `api/attachments/${$scope.project.imageAttachment.id}/download`;
          }
          return '../../../assert/sign.png';
        }

        $scope.uploadImage = function (file) {
          if (file) {
            $scope.$parent.uploadFile(file);
          }
        };

        $scope.openFileDialog = function () {
          document.getElementById("fileInput").click();
        };

        function isSelect() {
          return (
            $scope.projectLand != null &&
            $scope.projectLand.land != null &&
            $scope.projectLand.land.id != null
          );
        }
      },
    ],
  };
}
